// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"782":"9fd6b6d0","831":"6ec5ccfa"}[chunkId] + ".chunk.css";
};